import { render } from "./ComponentPropertyBoard.vue?vue&type=template&id=1347bf3a&scoped=true"
import script from "./ComponentPropertyBoard.vue?vue&type=script&lang=js"
export * from "./ComponentPropertyBoard.vue?vue&type=script&lang=js"

import "./ComponentPropertyBoard.vue?vue&type=style&index=0&id=1347bf3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1347bf3a"]])

export default __exports__